import React from "react";
import {AphLoanHistoryRow} from "./AphLoanHistoryRow";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {GridTable, ResultsPager} from "../../../../Components/Grid";
import {isAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";

interface AphLoanHistoryViewProps {
    aphLoanHistoryItems: Record<string, any>[];
    aphLoanHistorySearchCriteria: Record<string, any>;
    handleSetAphLoanHistorySearchCriteria: (criteria: Record<string, any>) => void;
    redirect?: (route: string) => void;
    totalRecords: number;
}

export const AphLoanHistoryView = ({
                                       aphLoanHistoryItems,
                                       aphLoanHistorySearchCriteria,
                                       handleSetAphLoanHistorySearchCriteria,
                                       totalRecords
                                   }: AphLoanHistoryViewProps) => {

    const isAphLoanHistoryItemsEmpty = isArrayNullOrEmpty(aphLoanHistoryItems);

    const handleOrderClick = (event: React.MouseEvent<HTMLElement>) => {
        let criteria = {...aphLoanHistorySearchCriteria};
        const columnId = (event.target as HTMLElement).dataset.id;
        criteria.UpdateSorting(columnId);
        handleSetAphLoanHistorySearchCriteria(criteria);
    };

    const handleFirstClick = () => {
        let criteria = {...aphLoanHistorySearchCriteria};
        criteria.First();
        handleSetAphLoanHistorySearchCriteria(criteria);
    };
    const handlePreviousClick = () => {
        let criteria = {...aphLoanHistorySearchCriteria};
        criteria.Previous();
        handleSetAphLoanHistorySearchCriteria(criteria);
    };
    const handleNextClick = () => {
        let criteria = {...aphLoanHistorySearchCriteria};
        criteria.Next();
        handleSetAphLoanHistorySearchCriteria(criteria);
    };
    const handleLastClick = () => {
        let criteria = {...aphLoanHistorySearchCriteria};
        criteria.Last(totalRecords);
        handleSetAphLoanHistorySearchCriteria(criteria);
    };

    const pager = (isSecondaryPager: boolean) =>
        <ResultsPager
            handleFirstClick={handleFirstClick}
            handlePreviousClick={handlePreviousClick}
            handleNextClick={handleNextClick}
            handleLastClick={handleLastClick}
            isSecondaryPager={isSecondaryPager}
            totalRecords={totalRecords}
            recordsPerPage={aphLoanHistorySearchCriteria.recordsPerPage}
            currentPage={aphLoanHistorySearchCriteria.page}
            disabled={false}
        />;

    return <>
        {pager(false)}
        <GridTable className="searchResults">
            <thead>
            <tr>
                <th onClick={handleOrderClick} className="is-clickable" data-id="aphCatalogTitle">Catalog Title</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="patronName">Patron</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="studentName">Student</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="districtName">District</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="organization">Organization</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="shippingLocationName">Shipping Location</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateFulfilledUtc">Order Fulfilled Date</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="aphLoanStatus">Status</th>
                {
                    isAdmin() &&
                    <th onClick={handleOrderClick} className="is-clickable" data-id="aphLoanNotes">Notes</th>
                }
            </tr>
            </thead>
            <tbody>
            {
                !isAphLoanHistoryItemsEmpty &&
                aphLoanHistoryItems.map((aphLoanHistoryItem: Record<string, any>) => {
                    return <AphLoanHistoryRow
                        key={aphLoanHistoryItem.aphLoanItemId}
                        aphLoanHistoryItem={aphLoanHistoryItem}
                    />;
                })
            }
            {
                isAphLoanHistoryItemsEmpty &&
                <tr data-testid={`no-order-row`}>
                    <td colSpan={isAdmin() ? 10 : 9} className={`text-center`}>No results found.</td>
                </tr>
            }
            </tbody>
        </GridTable>
        {pager(true)}
    </>;
};

